import { Link, useParams } from "react-router-dom";
import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";
import { useState, useEffect } from "react";
import DeleteModal from "../../../components/deleteModal/DeleteModal";

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from "../../../components/basics/Preloading";

const CashierManager = () => {
  const { branchId, deskId } = useParams();
  const [gridData, setGridData] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showFormModal, setShowFormModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [filterModel, setFilterModel] = useState({
    deskId: deskId,
    size: 20,
    part: 1,
    firstName: "",
    lastName: "",
    mobile: "",
    empCode: 0,
    total: 0,
    parts: 0,
  });
  const [findUserFilterModel, setfinddUserFilterModel] = useState({
    branchId: branchId,
    deskId: deskId,
    firstName: "",
    lastName: "",
    mobile: "",
    size: 20,
    empCode: 0,
    part: 1,
    total: 0,
    parts: 0,
  });
  const [selectUserModel, setSelectUserModel] = useState({
    id: 0,
    userId: 0,
    cashDeskId: deskId,
    employeeId: 0,
  });

  const getGridData = async (preload) => {
    if (preload) setLoading(true);
    const resp = await apiMethod.getCashDeskUsers(
      filterModel.deskId,
      filterModel.size,
      filterModel.part,
      filterModel.firstName,
      filterModel.lastName,
      filterModel.mobile,
      filterModel.empCode
    );
    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      setFilterModel({ ...filterModel });
      setGridData(resp.data);
    }
    if (preload) setLoading(false);
  };

  const findAllUsers = async () => {
    const resp1 = await apiMethod.findCahiers(
      findUserFilterModel.branchId,
      findUserFilterModel.deskId,
      findUserFilterModel.size,
      findUserFilterModel.part,
      findUserFilterModel.firstName,
      findUserFilterModel.lastName,
      findUserFilterModel.mobile,
      findUserFilterModel.empCode
    );
    if (methods.showApiErrors(resp1)) {
      findUserFilterModel.total = resp1.total;
      findUserFilterModel.parts = methods.calcPageParts(
        resp1.total,
        findUserFilterModel.size
      );
      setfinddUserFilterModel({ ...findUserFilterModel });
      setAllUsers(resp1.data);
    }
  };

  useEffect(() => {
    const bindData = async () => {
      await getGridData(true);
    };
    bindData();
  }, [branchId, deskId]);

  const showAllCashiers = () => {
    findAllUsers();
    setShowFormModal(true);
  };

  const selectUser = async (item) => {
    const updatedModel = {
      ...selectUserModel,
      employeeId: item.id,
      userId: item.userId,
    };
    setSelectUserModel(updatedModel);
    await addUserToCashDesk(updatedModel);
  };

  const addUserToCashDesk = async (model) => {
    setLoading(true);
    const resp = await apiMethod.createCashDeskUser(model);
    if (methods.showApiErrors(resp)) {
      await getGridData(false);
      setShowFormModal(false);
    }
    setLoading(false);
  };

  const selectَItemToDelete = (item) => {
    setSelectUserModel({ ...selectUserModel, id: item.id });
    setShowDeleteModal(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeCashDeskUser(selectUserModel.id);
      if (!methods.showApiErrors(resp)) return false;
      await getGridData(false);
      setSelectUserModel({
        id: 0,
        userId: 0,
        cashDeskId: deskId,
        employeeId: 0,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const resetFilters = () => {
    filterModel.deskId = deskId;
    filterModel.size = 20;
    filterModel.part = 1;
    filterModel.firstName = "";
    filterModel.lastName = "";
    filterModel.mobile = "";
    filterModel.empCode = 0;
    setFilterModel({ ...filterModel });
  };

  const resetFiltersModal = () => {
    findUserFilterModel.branchId = branchId;
    findUserFilterModel.deskId = deskId;
    findUserFilterModel.firstName = "";
    findUserFilterModel.lastName = "";
    findUserFilterModel.mobile = "";
    findUserFilterModel.empCode = 0;
    findUserFilterModel.size = 20;
    findUserFilterModel.part = 1;
    setFilterModel({ ...filterModel });
  };

  const searchItem = async () => {
    await getGridData(true);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData(false);
    setLoading(false);
  };

  const searchItemModal = async () => {
    setLoading(true);
    await findAllUsers();
    setLoading(false);
  };

  const clearSearchModal = async () => {
    setLoading(true);
    resetFiltersModal();
    await findAllUsers();
    setLoading(false);
  };

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (filterModel.parts < filterModel.part + 1) {
        return false;
      }
      callPager(filterModel.part + 1);
    } else {
      if (filterModel.part === 1) {
        return false;
      }
      callPager(filterModel.part - 1);
    }
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData(false);
    setLoading(false);
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= filterModel.parts; i++) {
      pages.push(
        <li
          key={i}
          className={
            filterModel.part === i ? "page-item active mx-1" : "page-item mx-1"
          }
        >
          <a
            className="page-link circular-pagination"
            onClick={() => {
              callPager(i);
            }}
          >
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className="d-none d-lg-block">
              <Link
                to={`/sale/${branchId}/cashDeskManage`}
                className="text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link
                  to={`/sale/${branchId}/cashDeskManage`}
                  className="link back-link"
                >
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                صندوق / تخصیص صندوق دار
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>صندوق / تخصیص صندوق دار</p>
            </div>
            <div className="salemain">
              <div className="salesearchsection">
                <div className="row g-1">
                  <div className="col-12 col-md-2">
                    <label htmlFor="funit" className="form-label">
                      نام
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      aria-label="Add your item here..."
                      style={{ direction: "rtl", textAlign: "right" }}
                      value={filterModel.firstName}
                      onChange={(e) => {
                        setFilterModel({
                          ...filterModel,
                          firstName: e.target.value,
                          part: 1,
                        });
                      }}
                    />
                  </div>
                  <div className="col-12 col-md-2">
                    <label htmlFor="funit" className="form-label">
                      {" "}
                      نام‌خانوادگی
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      aria-label="Add your item here..."
                      style={{ direction: "rtl", textAlign: "right" }}
                      value={filterModel.lastName}
                      onChange={(e) => {
                        setFilterModel({
                          ...filterModel,
                          lastName: e.target.value,
                          part: 1,
                        });
                      }}
                    />
                  </div>
                  <div className="col-12 col-md-2">
                    <label htmlFor="fstatus" className="form-label">
                      کد پرسنلی
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      aria-label="Add your item here..."
                      style={{ direction: "rtl", textAlign: "right" }}
                      value={filterModel.empCode}
                      onChange={(e) => {
                        setFilterModel({
                          ...filterModel,
                          empCode: e.target.value,
                          part: 1,
                        });
                      }}
                    />
                  </div>
                  <div
                    className="col-12 col-md-2 ps-0"
                    style={{ marginTop: "37px" }}
                  >
                    <button
                      type="button"
                      className="btn btn-purple me-1"
                      onClick={() => {
                        searchItem();
                      }}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-info"
                      onClick={clearSearch}
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                  <div className="col-12 col-md-4">
                    <div className="createButton">
                      <button
                        onClick={() => {
                          showAllCashiers();
                        }}
                        className="btn btn-outline-purple custome-btn"
                        type="button"
                      >
                        <span className="align-middle d-inline-block">
                          تخصیص صندوقدار
                        </span>{" "}
                        <i className="bi bi-plus-circle align-middle"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-responsive saletable">
                <table className="table table-striped table-md ">
                  <thead className="align-middle">
                    <tr>
                      <th scope="col vertical-center" width="20px">
                        ردیف
                      </th>
                      <th scope="col vertical-center">نام و نام خانوادگی</th>
                      <th scope="col vertical-center"> کد پرسنلی </th>
                      <th scope="col vertical-center"> شماره موبایل</th>
                      <th scope="col vertical-center" width="50px">
                        عملیات
                      </th>
                    </tr>
                  </thead>
                  <tbody className="align-middle">
                    {gridData.map((item, index) => (
                      <tr key={item.id}>
                        <th scope="row">
                          {(filterModel.part - 1) * filterModel.size +
                            index +
                            1}
                        </th>
                        <td>
                          {item.firstname} {item.lastname}
                        </td>
                        <td>{item.employeeCode}</td>
                        <td>{item.phoneNumber}</td>
                        <td>
                          <button
                            onClick={() => selectَItemToDelete(item)}
                            className="btn btn-sm btn-outline-danger"
                            type="button"
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {filterModel.parts > 1 && (
                  <nav aria-label="Page navigation example" className="mt-5">
                    <ul className="pagination justify-content-center">
                      <li className="page-item mx-1">
                        <a
                          className="page-link circular-pagination"
                          onClick={() => {
                            movePagerPart(false);
                          }}
                        >
                          <i className="bi bi-chevron-compact-right"></i>
                        </a>
                      </li>
                      {makePagerItems()}
                      <li className="page-item mx-1">
                        <a
                          className="page-link circular-pagination"
                          onClick={() => {
                            movePagerPart(true);
                          }}
                        >
                          <i className="bi bi-chevron-compact-left"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                )}
              </div>
            </div>
          </>
        }
      </>
    );
  };

  const closeModal = () => {
    setShowFormModal(false);
    setShowDeleteModal(false);
  };

  const Modal = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: showFormModal ? "block" : "none" }}
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">تخصیص صندوقدار </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              ></button>
            </div>
            <div className="modal-body">
              <div className="salesearchsection">
                <div className="row g-1">
                  <div className="col-12 col-md-3">
                    <label htmlFor="funit" className="form-label">
                      نام
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      aria-label="Add your item here..."
                      style={{ direction: "rtl", textAlign: "right" }}
                      value={findUserFilterModel.firstName}
                      onChange={(e) => {
                        setfinddUserFilterModel({
                          ...findUserFilterModel,
                          firstName: e.target.value,
                          part: 1,
                        });
                      }}
                    />
                  </div>
                  <div className="col-12 col-md-3">
                    <label htmlFor="funit" className="form-label">
                      {" "}
                      نام‌خانوادگی
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      aria-label="Add your item here..."
                      style={{ direction: "rtl", textAlign: "right" }}
                      value={findUserFilterModel.lastName}
                      onChange={(e) => {
                        setfinddUserFilterModel({
                          ...findUserFilterModel,
                          lastName: e.target.value,
                          part: 1,
                        });
                      }}
                    />
                  </div>
                  <div className="col-12 col-md-3">
                    <label htmlFor="fstatus" className="form-label">
                      کد پرسنلی
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      aria-label="Add your item here..."
                      style={{ direction: "rtl", textAlign: "right" }}
                      value={findUserFilterModel.empCode}
                      onChange={(e) => {
                        setfinddUserFilterModel({
                          ...findUserFilterModel,
                          empCode: e.target.value,
                          part: 1,
                        });
                      }}
                    />
                  </div>
                  <div
                    className="col-12 col-md-3 ps-0"
                    style={{ marginTop: "37px" }}
                  >
                    <button
                      type="button"
                      className="btn btn-purple me-1"
                      onClick={() => {
                        searchItemModal();
                      }}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-info"
                      onClick={clearSearchModal}
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div className="table-responsive saletable">
                <table className="table table-striped table-md align-middle">
                  <thead className="">
                    <tr>
                      <th scope="col vertical-center" width="20px">
                        ردیف
                      </th>
                      <th scope="col vertical-center">نام</th>
                      <th scope="col vertical-center">نام خانوادگی</th>
                      <th scope="col vertical-center">کدپرسنلی</th>
                      <th scope="col vertical-center"> شماره موبایل</th>
                      <th scope="col vertical-center" width="50px">
                        عملیات
                      </th>
                    </tr>
                  </thead>
                  <tbody className="">
                    {allUsers.map((item, index) => (
                      <tr key={item.id}>
                        <th scope="row">
                          {(findUserFilterModel.part - 1) *
                            findUserFilterModel.size +
                            index +
                            1}
                        </th>
                        <td>{item.firstname}</td>
                        <td>{item.lastname}</td>
                        <td>{item.employeeCode}</td>
                        <td>{item.phoneNumber}</td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-sm btn-purple"
                            onClick={() => selectUser(item)}
                          >
                            افزودن
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer d-inline-flex d-lg-flex">
              <button
                type="button"
                className="btn custome-btn btn-link-purple "
                onClick={closeModal}
              >
                انصراف
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {renderItems()}
      {showFormModal && Modal()}
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeModal}
          deleteItem={deleteItem}
          text={"صندوقدار"}
        />
      )}
    </>
  );
};

export default CashierManager;
